import { render, staticRenderFns } from "./UploadClaimDocuments.vue?vue&type=template&id=5eadbda1&scoped=true&"
import script from "./UploadClaimDocuments.vue?vue&type=script&lang=js&"
export * from "./UploadClaimDocuments.vue?vue&type=script&lang=js&"
import style0 from "./UploadClaimDocuments.vue?vue&type=style&index=0&id=5eadbda1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5eadbda1",
  null
  
)

export default component.exports